"use client";
import React, { useRef, useEffect } from "react";
import styles from "./CoinLabel.module.css";
import { FontIcon } from "@/app/_components";
import { SRewardAnimation } from "@/app/_components/Coin/SRewardAnimation";
import {useUser, useUserBaseInfo} from "@/app/context/UserContext";
import {DriveUtil} from "@/Master/DriveUtil";
import {RewardType} from "@/Core/Reward/RewardInfo";

export interface CoinLabelProps {
    type: RewardType;
    isShowAdd?: boolean;
    gc?: number;
    sc?: number;
    click?: () => void;
}

const CoinLabel: React.FC<CoinLabelProps> = (props) => {
    const {
        type = RewardType.GC,
        isShowAdd = false,
        gc = 0,
        sc = 0,
        click = () => {}
    } = props

    const containerRef = useRef<HTMLDivElement>(null);
    const coinIconRef = useRef<HTMLDivElement>(null);
    const coinTextRef = useRef<HTMLDivElement>(null);

    const user = useUser();
    const baseInfo = user.baseInfo;


    useEffect(() => {
        const current = containerRef.current;
        const icon = coinIconRef.current;
        const text = coinTextRef.current;

        if (current && icon && text) {
            SRewardAnimation.Init(current, icon, text);
        }

        return () => {
            console.log("CoinLabel unmounted");
        };
    }, []);

    return (
        <div
            ref={containerRef}
            className={`${styles.coinLabel} center-left ani ${isShowAdd ? styles.coinLabel_add : ""}`}
            onClick={(e) => e.stopPropagation()}
        >
            <div ref={coinIconRef} className={styles.type}>
                {user.rewardType === RewardType.SC ? "SC" : "GC"}
            </div>
            <div ref={coinTextRef} className={styles.coin}>
                {user.rewardType === RewardType.SC ?
                    DriveUtil.ToScString(baseInfo.scCount)
                    :
                    DriveUtil.ToGcString(baseInfo.gcAmount)}
            </div>
            <div
                className={`${styles.addBtn} btn`}
                onClick={(e) => {
                    e.stopPropagation();
                    click();
                }}
            >
                <div className={`${styles.add} center`}>
                    <FontIcon icon="s-add" />
                </div>
            </div>
        </div>
    );
};

export default CoinLabel;
